function getTimeDifference(date) {
	//returns a object with days, hours, minutes, seconds between today and given date

	//diff between 2 dates in milliseconds
	const diff = new Date(date) - new Date();
	//calculate subsequent values using milliseconds
	const seconds = Math.floor(diff / 1000);
	const minutes = Math.floor(seconds / 60);
	const hours = Math.floor(minutes / 60);
	const days = Math.floor(hours / 24);

	const timeObj = {
		days: days,
		hours: hours % 24,
		minutes: minutes % 60,
		seconds: seconds % 60,
	};

	return timeObj;
}

export { getTimeDifference };
